/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext } from 'react';

import { availableVideos } from '../../../services/mock';
import VideoSide from '../../VideoSide';

import { ContentSideMenu, ContentSideSide, ContentSideTitle } from './styled';
export default function VideoRecommendationSide({
  relateds,
}: {
  relateds: Array<Record<string, unknown>>;
}) {
  return (
    <>
      <ContentSideMenu>
        <ContentSideSide>
          <ContentSideTitle>Relacionados</ContentSideTitle>

          {relateds.map((item: Record<string, unknown>, key: number) => (
            <VideoSide key={key} item={item} />
          ))}
        </ContentSideSide>
      </ContentSideMenu>
    </>
  );
}
